import React from 'react';
import Grid from '@mui/material/Grid';
import { Box, IconButton } from '@mui/material';
import { FormInput } from 'components/molecules/FormInput';
import Button from 'components/atoms/Button';
import { EButtonVariants } from 'constants/Buttons';
import Icon from 'components/atoms/Icon/Icon';
import { EIconTypes } from 'constants/Icons';
import { colors } from 'theme/colors';
import { FormDatePicker } from 'components/molecules/FormDatePicker';

interface IAddOffenceListItem {
  index: number;
  arrayName?: string;
  control: any;
  errors: any;
  addNew: () => void;
  remove: (index: number) => void;
  count: number;
  currentOffenceDate: any;
  currentOffenceName: any;
  clearFields: (index: number) => void;
}

const AddOffenceListItem = ({
  index,
  arrayName,
  control,
  errors,
  addNew,
  remove,
  count,
  currentOffenceDate,
  currentOffenceName,
  clearFields,
}: IAddOffenceListItem) => {
  const isLastRow = count - 1 === index;
  const isFirstRow = index === 0;
  const hasData = currentOffenceDate || currentOffenceName;
  const isOnlyOffence = count === 1;
  const isDeleteDisabled = isFirstRow && !hasData;

  const handleDeleteClick = () => {
    if (isFirstRow && isOnlyOffence) {
      clearFields(index);
    } else {
      remove(index);
    }
  };

  return (
    <Box>
      <Grid container spacing={2.5} rowSpacing={0}>
        <Grid item xs={4} sx={{ paddingTop: '13px !important' }}>
          <FormDatePicker
            name={`${arrayName}[${index}].offenceDate`}
            label="Date"
            required
            fieldName="offenceDate"
            arrayName={arrayName}
            arrayIndex={index}
            control={control}
            errors={errors}
          />
        </Grid>
        <Grid item xs={7} sx={{ paddingTop: '13px !important' }}>
          <FormInput
            name={`${arrayName}[${index}].offenceName`}
            label="Offence"
            fieldName="offenceName"
            arrayName={arrayName}
            arrayIndex={index}
            control={control}
            errors={errors}
          />
        </Grid>
        <Grid
          item
          xs={1}
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            paddingTop: '41px !important',
          }}
        >
          <IconButton
            onClick={handleDeleteClick}
            aria-label="delete offence"
            disabled={isDeleteDisabled}
            sx={{ padding: 0 }}
          >
            <Icon
              type={EIconTypes.deleteBoxed}
              color={isDeleteDisabled ? colors.gray300 : colors.error700}
              fontSize={40}
            />
          </IconButton>
        </Grid>
        {isLastRow && (
          <Grid item xs={4} sx={{ marginTop: '1px' }}>
            <Button
              variant={EButtonVariants.outlined}
              label="Add new offence"
              fullWidth
              onClick={() => addNew()}
              disabled={!currentOffenceDate}
            />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default AddOffenceListItem;
